import { defaultBannerForm, defaultBatchBannerForm } from './utils';

export const initialFormState = (): FormState => ({
  data: {
    login: {
      email: '',
      password: '',
    },
    banner: defaultBannerForm(),
    recoverPassword: {
      code: '',
      email: '',
      password: '',
      passwordConfirmation: '',
    },
    batchBanner: defaultBatchBannerForm(),
  },
  blur: {
    recoverPassword: {
      email: false,
      password: false,
      passwordConfirmation: false,
    },
  },
});
